import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { QuestionGroupModel } from '../../../shared/model/question-group.model';


@Component({
	selector: 'app-question-group-form-modal',
	templateUrl: './question-group-form-modal.component.html',
	styleUrls: ['./question-group-form-modal.component.css']
})
export class QuestionGroupFormModalComponent implements OnInit {
	@Output() save = new EventEmitter<QuestionGroupModel>();
	display: boolean;
	editing: boolean;
	orderLimit:number;
	questionGroup: QuestionGroupModel = new QuestionGroupModel();

	constructor(private translateService: TranslateService,) {}

	ngOnInit() {}

	saveGroup() {
		this.save.emit(this.questionGroup);
	}

	validate() {
		return QuestionGroupModel.validate(this.questionGroup) && this.questionGroup.weight <= 100;
	}

	onCloseModal() {
		this.questionGroup = new QuestionGroupModel();
	}

	translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) =>
	this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);				
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/question-group/question-group-form-modal/question-group-form-modal.component.ts